<template>
    <ul>
        <!-- 点赞 -->
        <li class="like">
            <Like :likeData="likeData" />
        </li>
        <!-- 收藏 -->
        <li class="collection">
            <Collection :collectionData="collectionData" />
        </li>
        <li>
            <div class="line"></div>
        </li>
        <!-- 微信 -->
        <li class="weixin" @mouseenter="renderQrcode">
            <div class="icon weixin-icon"></div>
            <div class="wx-code">
                <div class="cort"></div>
                <div class="code-pic">
                    <div id="qrcode" class="qrcode"></div>
                </div>
            </div>
        </li>
        <!-- 微博 -->
        <li class="sinat">
            <a :href="sinaUrl" target="_blank" data-clev="10220259" :data-spm-acode="shareAction"
                data-spm-click-pm="shareCode:weibo">
                <em class="icon sinat-icon"></em>
            </a>
        </li>
        <!-- qq空间 -->
        <li class="qzone">
            <a :href="qzoneUrl" target="_blank" data-clev="10220260" :data-spm-acode="shareAction"
                data-spm-click-pm="shareCode:qqz">
                <em class="icon qzone-icon"></em>
            </a>
        </li>
    </ul>
</template>

<script>
import QRCode from 'qrcodejs2';
import Utils from '@/utils/Utils';
import { acodeConfig } from '@/config/spmConfig';
import { getInteracitonCountApi } from '@/request/request'
import Collection from '@/vuecomps/shareInteraction/collection.vue'
import Like from '@/vuecomps/shareInteraction/like.vue'

export default {
    name: 'ShareComponent',
    components: {
        Collection,
        Like
    },
    computed: {
        qrcodeUrl() {
            return "/a/" + window.pcArticleInfo?.news_id + "_" + window.pcArticleInfo?.media_id;
        }
    },
    data() {
        return {
            param: {
                webid: '',
                name: '',
                title: document.title,
                url: window.location.href,
                pic: '',
                content: '',
                sina_appkey: '',
                tencent_appkey: '',
                qrcodeUrl: '',
            },
            mobileHost: Utils.getWapSohuHost(),
            sinaUrl: '',
            qzoneUrl: '',
            shareAction: acodeConfig.shareAction,
            rendered: false,
            likeData: {},
            collectionData: {}
        };
    },
    mounted() {
        this.getInteracitonCount()
        this.param.pic = document.querySelector('article img')?.src || '';
        this.param.qrcodeUrl = `${this.mobileHost}${this.qrcodeUrl}/?_trans_=010005_pcwzywxewmsm`;

        this.sinaUrl = `http://service.weibo.com/share/share.php?url=${encodeURIComponent(this.param.url)}&title=${encodeURIComponent(this.param.title)}&searchPic=true&pic=${this.param.pic}&appkey=2890110694`;

        const qzoneBase = `http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${encodeURIComponent(this.param.url)}`;
        this.qzoneUrl = process.env.ISPROD ? qzoneBase : `${qzoneBase}&title=${encodeURIComponent(this.param.title)}&searchPic=true&pics=${this.param.pic}?imageView&thumbnail=550x0&desc=`;
    },
    methods: {
        init() {
        },
        // 获取互动数量
        async getInteracitonCount() {
            let res = await getInteracitonCountApi()
            if (res.code == 1 && res.data) {
                let countObj = res?.data?.[`mp_${window.pcArticleInfo?.news_id}`]
                // 点赞
                this.likeData = {
                    isLiked: countObj?.[12]?.optionInfos?.[0]?.operated,
                    likeCount: countObj?.[12]?.optionInfos?.[0]?.count
                }
                // 收藏
                this.collectionData = {
                    isCollection: countObj?.[11]?.optionInfos?.[0]?.operated,
                    collectionCount: countObj?.[11]?.optionInfos?.[0]?.count
                }

            }
        },
        renderQrcode() {
            if (window.sohuSpm && typeof window.sohuSpm.sendAction === 'function') {
                window.sohuSpm.sendAction({
                    acode: acodeConfig.shareAction,
                    clkParam: 'shareCode:wxf'
                });
            }

            if (this.rendered) {
                return;
            }

            const qrcodeDom = document.querySelectorAll('#qrcode');
            qrcodeDom.forEach(dom => {
                new QRCode(dom, {
                    text: this.param.qrcodeUrl,
                    width: 90,
                    height: 90,
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: QRCode.CorrectLevel.H
                });
            });

            this.rendered = true;
        }
    }
}
</script>

<style lang="less">
#qrcode {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    img {
        width: 90px;
        height: 90px;
    }
}

.share {
    position: relative;

    ul {
        display: flex;
        align-items: center;
        right: 0;
        z-index: 1;
    }

    li {
        float: left;

        .icon {
            width: 22px;
            height: 22px;
            margin-left: 22px;
        }


        .sinat-icon {
            background: url(../images/icon_weibo1@2x.png) no-repeat 0 0;
            background-size: 100% 100%;
        }

        .weixin-icon {
            background: url(../images/icon_wechat1@2x.png) no-repeat 0 0;
            background-size: 100% 100%;
        }

        .qzone-icon {
            background: url(../images/icon_qzone1@2x.png) no-repeat 0 0;
            background-size: 100% 100%;
        }

        .line {
            margin-left: 20px;
            width: 1px;
            height: 18px;
            background: #333;
            margin-top: 3px;
        }
    }

    .like .like-c {
        .wrap {
            display:flex;
            justify-content:space-around;
            align-items:center;
        }
        display: flex;
        align-items: center;

        .icon {
            width: 22px;
            height: 22px;
            background-color: transparent !important;

            .like-icon {
                background: url('https://statics.itc.cn/mptc-mpfe/img/article/icon_praised.png') no-repeat 0 0;
                background-size: 100% 100%;
            }

            .no-like-icon {
                background: url('../images/icon_praise@2x.png') no-repeat 0 0;
                background-size: 100% 100%;
            }
        }

        .count {
            margin: 0;
            margin-left: 4px;
            color: #fff;
            font-size: 12px;
        }
    }

    .collection .collection-c,
    {
    display: flex;
    align-items: center;

    .icon {
        width: 22px;
        height: 22px;
        background-color: transparent !important;

        .collection-icon {
            background: url('../images/wap-yellow-collection.png') no-repeat 0 0;
            background-size: 100% 100%;
        }

        .no-collection-icon {
            background: url('../images/icon_collection_line4.png') no-repeat 0 0;
            background-size: 100% 100%;
        }
    }

    .count {
        margin: 0;
        margin-left: 5px;
        color: #fff;
        font-size: 12px;
    }
}

li.tt {
    line-height: 22px;
    margin: 0;
    color: #999;
    font-size: 14px;
}

.weixin {
    position: relative;
}

.wx-code {
    display: none;
    position: absolute;
    top: 30px;
    left: -48px;
    width: 120px;
    height: 120px;
    background: url('../images/share-box.png') -3px 0 no-repeat;
    z-index: 10;

    .cort {
        display: none;
    }

    .code-pic {
        height: 100px;
        margin-top: 16px;
        display: flex;
        align-items: center;
    }

    p {
        font-size: 14px;
        line-height: 20px;
        color: #191919;
    }
}

.weixin:hover .wx-code {
    display: block;
}
}
</style>
